import { render, staticRenderFns } from "./LabelSlotsStructure.vue?vue&type=template&id=4c8a6d9d"
import script from "./LabelSlotsStructure.vue?vue&type=script&lang=ts"
export * from "./LabelSlotsStructure.vue?vue&type=script&lang=ts"
import style0 from "./LabelSlotsStructure.vue?vue&type=style&index=0&id=4c8a6d9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports